import React from 'react'
import { makeKiddomPatchRequest } from 'infrastructure/api'
import SearchSchools from './SearchSchools'
import { List } from 'infrastructure/api'
import { scrollToBottom } from '../../utility/utils'

const AddSchoolToDistrict = ({
  data,
  refetchDistrictSchools,
}: {
  data: any
  refetchDistrictSchools: () => void
}) => {
  const onSubmit = async (schoolID: number) => {
    const requestBody = {
      school_id: schoolID,
      district_id: parseInt(data.id),
    }
    await makeKiddomPatchRequest({ kiddomPath: `/v1/sis/school`, requestBody })
    refetchDistrictSchools()
    scrollToBottom()
  }
  const disableButton = (districtSchool: List.School) => {
    return districtSchool.district?.name !== undefined
  }
  return <SearchSchools submitFn={onSubmit} disableFn={disableButton} />
}

export default AddSchoolToDistrict
